import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/system-usage")({
  component: SystemUsageLayout,
});

function SystemUsageLayout() {
  return <Outlet />;
}
